import { ROUTES } from '_/constants/routes'
import { parseDay } from '_/features/journ/domain/types'
import { JournDayPage } from '_/features/journ/ui/pages/journ-day-page'
import { createFileRoute, Navigate } from '@tanstack/react-router'

const JournDayRoute = () => {
	const { day } = Route.useParams()
	const parsed = parseDay(day)
	return parsed ? <JournDayPage day={parsed} /> : <Navigate to={ROUTES.journ.root} replace />
}

export const Route = createFileRoute('/_authenticated/journ/$day')({
	staticData: { title: 'journ_title' },
	component: JournDayRoute,
})
